import { Section, Text } from "@react-email/components";
import useThemeContextualColors, {
  sectionToParent,
} from "../../hooks/use-theme-contextual-colors";
import { useReturnVariableValues } from "../../hooks/use-return-variable-values";
import type { ReturnDiscountCodeBlockProps } from "./types";

export function ReturnDiscountCodeEmailRenderer({
  theme,
  section,
}: ReturnDiscountCodeBlockProps) {
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const { discountCode } = useReturnVariableValues().getDiscountCode();

  // Auto-hide when there is no code (e.g. store credit applied automatically
  // at checkout) — the single template covers both cases, this block only
  // renders for discount-code / gift-card returns.
  if (!discountCode) return null;

  return (
    <Section className="px-4">
      <Section
        className="mx-auto rounded-md"
        style={{ backgroundColor: "rgba(0,0,0,.05)", maxWidth: "280px" }}
      >
        <Text
          className="m-0 py-2 text-center font-bold"
          style={{
            color: colors.text,
            fontSize: "18px",
            letterSpacing: "2px",
            lineHeight: "40px",
          }}
        >
          {discountCode}
        </Text>
      </Section>
    </Section>
  );
}
